import { useState } from 'react'
import { ref, push, set } from 'firebase/database'
import { db } from '../lib/firebase.js'
import CLUB from '../config/club.js'

const NAVY = 'var(--ge-primary)'
const ACCENT = 'var(--ge-accent)'

// Contact capture for the NOT-self-serve requests (entry-fee payments setup,
// custom branding). No processor — writes to /contactRequests (global node).
export default function ContactUs() {
  const [topic, setTopic] = useState('payments')
  const [name, setName] = useState('')
  const [email, setEmail] = useState('')
  const [club, setClub] = useState('')
  const [message, setMessage] = useState('')
  const [done, setDone] = useState(false)
  const [err, setErr] = useState('')
  const [busy, setBusy] = useState(false)

  const submit = async (e) => {
    e.preventDefault(); setErr('')
    if (!name.trim() || !email.trim()) { setErr('Name and email are required.'); return }
    setBusy(true)
    try {
      await set(push(ref(db, 'contactRequests')), {
        topic, name: name.trim(), email: email.trim(), club: club.trim() || null,
        message: message.trim() || null, createdAt: Date.now(),
      })
      setDone(true)
    } catch (e2) { setErr(e2?.message || 'Could not send.'); setBusy(false) }
  }

  return (
    <div className="min-h-full flex flex-col" style={{ background: '#FFFFFF' }}>
      <header className="flex items-center px-6 py-4" style={{ background: NAVY }}>
        <img src={CLUB.logo} alt={CLUB.name} style={{ height: 32, objectFit: 'contain' }} />
      </header>
      <div className="flex-1 flex items-center justify-center px-6 py-10">
        <div className="w-full max-w-md rounded-2xl p-6" style={{ border: '1px solid var(--ge-line,#E3E8EF)' }}>
          {done ? (
            <>
              <div className="text-5xl text-center mb-2">✓</div>
              <p className="text-center font-extrabold text-lg" style={{ color: NAVY }}>Request sent</p>
            </>
          ) : (
            <form onSubmit={submit} className="space-y-3">
              <h1 className="text-2xl font-extrabold" style={{ color: NAVY }}>Contact us</h1>
              <select className="ge-c-input" value={topic} onChange={(e) => setTopic(e.target.value)}>
                <option value="payments">Entry-fee payments setup</option>
                <option value="branding">Custom branding</option>
              </select>
              <input className="ge-c-input" placeholder="Your name" value={name} onChange={(e) => setName(e.target.value)} />
              <input className="ge-c-input" type="email" autoCapitalize="none" placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} />
              <input className="ge-c-input" placeholder="Club" value={club} onChange={(e) => setClub(e.target.value)} />
              <textarea className="ge-c-input" rows={4} placeholder="How can we help?" value={message} onChange={(e) => setMessage(e.target.value)} />
              {err ? <p className="text-sm font-bold" style={{ color: 'var(--ge-alert,#D6483E)' }}>{err}</p> : null}
              <button type="submit" disabled={busy} className="w-full py-3 rounded-xl font-extrabold uppercase tracking-wide disabled:opacity-50" style={{ background: ACCENT, color: '#FFFFFF' }}>
                {busy ? 'Sending…' : 'Send'}
              </button>
            </form>
          )}
        </div>
      </div>
      <style>{`.ge-c-input{width:100%;padding:10px 12px;border-radius:10px;border:1px solid var(--ge-line,#E3E8EF);background:#fff;color:var(--ge-ink,#16233C);font-size:15px}.ge-c-input:focus{outline:2px solid var(--ge-accent,#2E6FE6)}`}</style>
    </div>
  )
}
